import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-link-attachment',
    templateUrl: './link-attachment.component.html',
    styleUrls: ['./link-attachment.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule
    ]
})
export class LinkAttachmentComponent implements OnInit {

  @Output() attachElement: EventEmitter<any> = new EventEmitter();

  model: any = {
    title: "",
    link: ""
  };

  constructor() { }

  ngOnInit(): void { }

  onSubmit(form: NgForm) {
    if (!form.form.valid)
      return;

    // Emit the link object with type LINK
    this.attachElement.emit({
      type: 'LINK',
      title: this.model.title,
      link: this.model.link
    });

    // Reset model
    this.model = {
      title: "",
      link: ""
    };
  }
}
